<template>
    <div class="skinSet">
        <div class="base-form-div">
            <el-form size="mini" :label-position="labelPosition" label-width="100px" :model="formSet">
                <el-form-item label="系统皮肤">
                    <el-radio-group @input="selectChange" v-model="formSet.skin">
                        <el-radio :label="'blue-skin'">深蓝色</el-radio>
                        <el-radio :label="'white-skin'">高级灰</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            labelPosition: "left",
            formSet: {
                skin: localStorage.getItem("sysConfig-skin") || "blue-skin"
            }
        };
    },
    
    mounted() {

    },

    methods: {
        selectChange(val) {
            this.removeAll();
            document.body.classList.add(val);
            localStorage.setItem("sysConfig-skin",val);
        },
        removeAll() {
            var classList = ["blue-skin", "white-skin"];
            for (let i = 0; i < classList.length; i++) {
                document.body.classList.remove(classList[i]);
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.skinSet {
    padding: 20px;
}
</style>